<template>
  <section>
    <div class="buttons" v-if="linkType === 'button'">
      <a
        class="bd-tw-button button has-text-grey-dark"
        @click="isCardModalActive = true"
      >
        <span class="icon">
          <vue-fontawesome :icon="['fas', 'info']" />
        </span>
        <span> About </span>
      </a>
    </div>
    <div class="buttons" v-if="linkType === 'icon'">
      <a @click="isCardModalActive = true" class="has-text-grey-dark">
        <span class="icon">
          <vue-fontawesome :icon="['fas', 'info']" />
        </span>
      </a>
    </div>

    <b-modal
      v-model="isCardModalActive"
      scroll="keep"
      custom-class="pd-small-touch"
      :width="640"
    >
      <div class="card">
        <div class="card-content">
          <div class="content">
            <p
              class="
                content
                is-flex is-justify-content-center is-align-content-center
              "
            >
              <img
                src="../assets/images/logo.svg"
                alt="TV Tweets"
                class="image is-64x64"
              />
            </p>
            <h1 class="has-text-centered is-size-4-mobile">About TV tweets</h1>
            <p class="content is-size-6-desktop is-size-7-touch">
              TV Tweets has been brought to you by Buzz Bingo.
            </p>
            <p class="content is-size-6-desktop is-size-7-touch">
              Data for each show was collected via their generic Twitter hashtag
              (e.g. #gameofthrones) posted within the past 12 months. This
              ensured fairness throughout the study.
            </p>
            <p class="content is-size-6-desktop is-size-7-touch">
              Tweets were analysed using Professor Mike Thelwall's TensiStrength
              tool.
            </p>
            <p class="content is-size-6-desktop is-size-7-touch">
              TensiStrength estimates stress levels in short texts based on the
              classification of words related to stress, frustration, anxiety,
              anger and other negative emotions (more information can be found
              here). The scale used to measure tweets is as follows: -1 (no
              stress), -2 (low stress), -3 (moderate stress), -4 (high stress),
              -5 (very high stress). Our final ranking is based on the TV shows
              which had the highest proportion of tweets classified as -2 (low
              stress) to -5 (very high stress).
            </p>
            <p class="content is-size-6-desktop is-size-7-touch">
              Data last updated: September 2021
            </p>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
  export default {
    props: {
      linkType: String,
    },
    data() {
      return {
        isImageModalActive: false,
        isCardModalActive: false,
      };
    },
    methods: {
      isLinkBtn() {
        return this.linkType === "button";
      },
    },
  };
</script>
